import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";

import Header from "./Header";
//  actions
import {
  fetchPhysicalOrganizations,
  fetchTaxonomy
} from "../store/actions/organizations-action";

const PhysicalOrganizations = () => {
  const dispatch = useDispatch();

  const organizationsList = useSelector(
    state => state.organizationsConfiguration.physicalOrganizationsList
  );

  const taxonomyList = useSelector(
    state => state.organizationsConfiguration.taxonomyList
  );


  const hasError = useSelector(
    state => state.organizationsConfiguration.physicalOrganizationsError
  );

  const isListLoaded = useSelector(
    state => state.organizationsConfiguration.physicalOrganizationsListLoaded
  );


  const [organizationsListState, setOrganizationsListState] = useState(
    organizationsList
  );



  // Filter state
  const [filters, setFilters] = useState({
    country: "NZ",
    category: "Custom",
    subcategory: "Outdoor Media"
  });

  const [isSearching, setIsSearching] = useState(false);


  const handleSearch = () => {
    setIsSearching(true);
    dispatch(fetchPhysicalOrganizations(filters));
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  useEffect(() => {
    console.log('Dispatching fetchTaxonomy and fetchPhysicalOrganizations');
    dispatch(fetchTaxonomy());
    // Load initial data with default filters
    dispatch(fetchPhysicalOrganizations(filters));
  }, []);

  useEffect(() => {
    setOrganizationsListState(organizationsList);
    setIsSearching(false);
  }, [organizationsList]);




  //Table columns
  const columns = [
    {
      name: "id",
      label: <strong>ID</strong>,
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: "name",
      label: <strong>Name</strong>,
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: "country",
      label: <strong>Country</strong>,
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: "category",
      label: <strong>Category</strong>,
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: "subcategory",
      label: <strong>Subcategory</strong>,
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: "organisationType",
      label: <strong>Type</strong>,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return value === "physical" ? "Physical" : value;
        }
      }
    },
    {
      name: "poiInfo",
      label: <strong>POI Info</strong>,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          if (value && typeof value === 'object') {
            return (
              <div style={{ fontSize: '12px' }}>
                <div>Total: {value.total || 0}</div>
                <div>Active: {value.active || 0}</div>
                <div>Archived: {value.archived || 0}</div>
              </div>
            );
          }
          return "N/A";
        }
      }
    },
    {
      name: "",
      label: <strong>Actions</strong>,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const organizationId = tableMeta.rowData[0]; // First column is id
          return (
            <Link
              to={`/physical-organizations/${organizationId}/pois`}
              style={{ color: '#1976d2', textDecoration: 'none' }}
            >
              View POIs
            </Link>
          );
        }
      }
    },
  ];

  // Table Options
  const options = {
    filterType: "dropdown",
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: "none",
    responsive: "scrollFullHeight",
    customFilterDialogFooter: () => <FilterDialogFooter />
  };

  // Table Custom theme
  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableHeadCell: {
          fixedHeader: {
            backgroundColor: "#C2DFFF"
          }
        },
        MUIDataTableSelectCell: {
          headerCell: {
            backgroundColor: "#C2DFFF"
          }
        },
        MuiTable: {
          root: {
            marginTop: 10
          }
        }
      }
    });

  // Prepare taxonomy options for dropdowns
  console.log('Taxonomy List:', taxonomyList);
  console.log('Filters:', filters);

  const categoryOptions = taxonomyList && Array.isArray(taxonomyList)
    ? taxonomyList.map(item => ({ value: item.category, label: item.category }))
    : [];

  const subcategoryOptions = taxonomyList && Array.isArray(taxonomyList)
    ? taxonomyList
        .filter(item => item.category === filters.category)
        .flatMap(item => item.subcategories || [])
        .map(subcategory => ({ value: subcategory, label: subcategory }))
    : [];

  console.log('Category Options:', categoryOptions);
  console.log('Subcategory Options:', subcategoryOptions);

  const countryOptions = [
    { value: "NZ", label: "New Zealand" },
    { value: "AU", label: "Australia" },
  ];

  return (
    <div>
      <Header />
      <div style={{ padding: 20 }}>
        <h2>Physical Organizations</h2>

        {/* Filter Form */}
        <div style={{
          backgroundColor: '#f5f5f5',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '20px',
          border: '1px solid #e0e0e0'
        }}>
          <h3 style={{ margin: '0 0 15px 0', fontSize: '16px', color: '#333' }}>Filter Organizations</h3>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm={3}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Country</label>
              <Select
                value={countryOptions.find(option => option.value === filters.country)}
                onChange={(selectedOption) => handleFilterChange('country', selectedOption.value)}
                options={countryOptions}
                placeholder="Select Country"
                isSearchable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '40px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#999'
                    }
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                    marginTop: '4px'
                  }),
                  menuPortal: (provided) => ({
                    ...provided,
                    zIndex: 9999
                  })
                }}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Category</label>
              <Select
                value={categoryOptions.find(option => option.value === filters.category) || null}
                onChange={(selectedOption) => {
                  handleFilterChange('category', selectedOption ? selectedOption.value : '');
                  // Reset subcategory when category changes
                  handleFilterChange('subcategory', '');
                }}
                options={categoryOptions}
                placeholder="Select Category"
                isSearchable
                isClearable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '40px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#999'
                    }
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                    marginTop: '4px'
                  }),
                  menuPortal: (provided) => ({
                    ...provided,
                    zIndex: 9999
                  })
                }}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Subcategory</label>
              <Select
                value={subcategoryOptions.find(option => option.value === filters.subcategory) || null}
                onChange={(selectedOption) => handleFilterChange('subcategory', selectedOption ? selectedOption.value : '')}
                options={subcategoryOptions}
                placeholder="Select Subcategory"
                isSearchable
                isClearable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '40px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#999'
                    }
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                    marginTop: '4px'
                  }),
                  menuPortal: (provided) => ({
                    ...provided,
                    zIndex: 9999
                  })
                }}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSearch}
                disabled={!isListLoaded}
                style={{
                  marginTop: '25px',
                  minHeight: '40px',
                  width: '100%'
                }}
              >
                {!isListLoaded ? 'Searching...' : 'Search'}
              </Button>
            </Grid>
          </Grid>
        </div>

        <MuiThemeProvider theme={getMuiTheme()}>
          {!isListLoaded ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              backgroundColor: '#f9f9f9',
              border: '1px solid #e0e0e0',
              borderRadius: '4px',
              marginTop: '20px'
            }}>
              <h3 style={{ color: '#666', margin: '0 0 10px 0' }}>Searching...</h3>
              <p style={{ color: '#999', margin: '0' }}>Please wait while we fetch the organizations.</p>
            </div>
          ) : hasError || (organizationsListState && organizationsListState.length === 0) ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              backgroundColor: '#f9f9f9',
              border: '1px solid #e0e0e0',
              borderRadius: '4px',
              marginTop: '20px'
            }}>
              <h3 style={{ color: '#666', margin: '0 0 10px 0' }}>No Results Found</h3>
              <p style={{ color: '#999', margin: '0' }}>
                {hasError ? 'There was an error loading the data. Please try again.' : 'No organizations match your current filters.'}
              </p>
            </div>
          ) : (
            <MUIDataTable
              data={organizationsListState}
              columns={columns}
              options={options}
            />
          )}
        </MuiThemeProvider>
      </div>
    </div>
  );
};
export default PhysicalOrganizations;

export const FilterDialogFooter = () => <Box width={450} />;
